import { Component } from '@angular/core';

@Component({
    selector: 'su-root',
    template: `
        <block-ui [message]="message">
            <router-outlet></router-outlet>
            <cl-modal></cl-modal>
            <cl-session-expiring-modal></cl-session-expiring-modal>
        </block-ui>
    `,
    standalone: false
})
export class AppComponent {
    message: string = $localize`:@@3894950702316166331:Loading...`;
}